import type { FaireProductEntity } from "../../entity_types/product";

export const p_yncne6xkdz: FaireProductEntity = {
  token: "p_yncne6xkdz",
  type: "product",
  name: "Heart Jacquard Knit Coat",
  brandToken: "b_wrt3xtnbxw",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/6ead8127fdf6608bf8ec893ecc95ce653f698335b23fb89f663bea14faf6d400.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/90994edd8710d91c8a2e4456b4158be7ea6c7524ef0d52240ea3df074dedf614.jpeg",
    "https://cdn.faire.com/fastly/c7f41814c09ae1f03915e66ea386efc8d72d5bac3708eec672a2addd9c317cca.jpeg",
    "https://cdn.faire.com/fastly/929c8483f34a2e59f849cadcb974e43d0ea60c43b6d9687df1e14fda2a3a12e3.jpeg",
    "https://cdn.faire.com/fastly/3d238c3eb4d583306d30fdf76c49eefb40977977bd88b96dfee5525b99a009c1.jpeg",
    "https://cdn.faire.com/fastly/cd48a76948c09a1b0a6cf0a87458dc53f601d69f6121cf27b27a484d676de9d6.jpeg",
    "https://cdn.faire.com/fastly/d8aaf9b25b031fb41a2f8bd2e9a414217c67f12ca2db9129b9bf19513d682f2c.jpeg",
    "https://cdn.faire.com/fastly/6b5344f58f54777b3bf1441ffa0355b43a7ba8b7dcb76035fcabd5d2c4880c5a.jpeg",
    "https://cdn.faire.com/fastly/fbf93f916f762df347f9d10bb58cd504a2fc5825f54fd9f35f13ecddae873de1.jpeg",
    "https://cdn.faire.com/fastly/d9c06ee42be57ccc505ef12eff94442d95c63ccd2efe271cd71afc0e8708f8ff.jpeg",
    "https://cdn.faire.com/fastly/0d88b7c194fdf3ea2b9d4a180cfbaf90f8445cfce99c155b87704c37eaad84f2.jpeg",
    "https://cdn.faire.com/fastly/19ed00c5cffe8ed40936cf796c05ccc07ff4370f94c4f5ad86cbe39316997ddd.png"
  ],
  priceDollars: 46.5,
  description: "WRAP YOURSELF IN COZY CHARM WITH THIS ELEGANT KNIT COAT, FEATURING A DELICATE HEART JACQUARD PATTERN AND A FLOWING OVERSIZED SILHOUETTE.\n\nIMPORTED, DESIGNED IN USA\n\nALL-OVER HEART JACQUARD KNIT PATTERN\n\nOVERSIZED, MID-LENGTH COAT DESIGN\n\nCONT 100% ACRYLIC\n\nModel is 5'9\" and is wearing a small. Please see size chart for detail.\n\nPlease note: This product ships from China. We cover all customs and import duties for you! Delivery takes 4-5 business days after your order ships. Please contact us if you have any questions.",
  tags: [],
  msrpDollars: 93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:48.038Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
